<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{!serviceId ? 'Add' : 'Update'}} service request</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="serviceRequestForm" style="width: 100%;">

          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" formControlName="title">
              <mat-error
                *ngIf="serviceRequestForm.controls['title'].touched && serviceRequestForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <input matInput placeholder="Description" formControlName="description">
              <mat-error
                *ngIf="serviceRequestForm.controls['description'].touched && serviceRequestForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Cover Item</mat-label>
              <mat-select formControlName="coveredItemId">
                <mat-option *ngFor="let item of coverItems" [value]="item['planCoverItemId']">
                  {{item['title']}}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="serviceRequestForm.controls['coveredItemId'].touched && serviceRequestForm.controls['coveredItemId'].hasError('required')">
                this field is required
              </mat-error>
            </mat-form-field>
            <div *ngIf="this.serviceRequestForm.value.isParent === 'no'">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Services</mat-label>
                <mat-select formControlName="parent_service_id">
                  <mat-option *ngFor="let parent of parentlist" [value]="parent['serviceId']">
                    {{parent['title']}}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="serviceRequestForm.controls['parent_service_id'].touched && serviceRequestForm.controls['parent_service_id'].hasError('required')">
                  this field is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
           
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="submit()"><span>{{!serviceId ? 'Add' : 'Update'}}</span></button>
          </div>
  
          </form>
    </div>
  </div>

